module.exports = {
    "page.im.setting.imForm.to": "Đến",
    "page.im.window.prdSearchPlaceholder": "Vui lòng nhập tiêu đề sản phẩm",
    "page.import.import": "Nhập dữ liệu",
    "page.im.window.label.totalReturns": "Tổng lợi nhuận",
    "page.im.window.label.unread": "Chưa đọc",
    "page.im.window.messageInputPlaceholder": "Loại tin nhắn ở đây, Nhập để gửi tin nhắn",
    "lazada_im_sticker_no": "NO",
    "im.messageList.returnReason": "Lí do trả hàng",
    "im.messageList.failedStatus": "Gửi tin nhắn thất bại. {resend} hoặc {delete}",
    "page.import.historyBox.col.processed": "Processed",
    "im.messageList.unpaidOrderItemTip": "Tổng sản phẩm",
    "page.im.window.label.orderTime": "Thời gian đặt hàng",
    "page.import.tab.template": "Lịch sử template",
    "page.import.footer.button.another": "Nhập thông tin khác",
    "page.import.importBox.infos.1": "Để tạo hay đăng sản phẩm vui lòng sử dụng các tài liệu có định dạng CSV (.csv) hoặc MS Excel",
    "page.import.importBox.infos.2": "Lưu ý: file Excel không được chứa công thức và vùng tham chiếu.",
    "page.im.window.follow": "Thực hiện theo",
    "page.im.setting.imForm.from": "Từ",
    "im.messageList.view": "Xem",
    "page.im.window.filter.read": "Đã đọc",
    "page.im.window.label.totalItems": "Tổng số mặt hàng",
    "page.im.window.filter.all": "Tất cả",
    "page.import.importBox.templateTitle": "Tải tài liệu mẫu",
    "page.im.window.oversize": "Tập tin tải lên quá lớn (phải nhỏ hơn 50M)",
    "lazada_im_sticker_thankyou": "Cám ơn bạn",
    "page.im.setting.assignment.placeholder": "Email, Tên Người dùng",
    "page.im.setting.btn.remove": "Xóa",
    "page.im.window.label.read": "Đã đọc",
    "page.import.importBox.importModeText": "Chế độ nhập",
    "page.im.setting.current.desc": "trong tất cả các trang đã chọn",
    "im.messageList.payNow": "Thanh toán ngay",
    "page.im.window.sessionFilterPlaceholder": "Tìm kiếm tên khách hàng...",
    "im.messageList.confirm": "Địa chỉ chính xác",
    "im.messageList.unpaidOrderTitle": "Nhắc nhở đơn hàng chưa thanh toán",
    "page.im.setting.btn.addUser": "Thêm Người dùng",
    "page.im.window.label.productName": "Tên Sản phẩm",
    "page.im.window.voucher.sendBatch.creatingTitle": "Tạo mã giảm giá mới",
    "im.messageList.orderDate": "Ngày đặt hàng",
    "page.import.historyBox.feedback.success": "Quá trình nhập thông tin đã hòan tất",
    "page.im.window.tab.order": "Gọi món",
    "page.import.tab.history": "Import History",
    "page.im.window.label.order": "Đơn hàng",
    "im.messageList.lazMall": "LazMall",
    "page.im.window.send": "Gửi",
    "page.im.window.discount.cashLabelPrefixLine2": "trị tiền",
    "im.messageList.reviewShippingInformationAddress": "Địa chỉ giao hàng",
    "page.im.window.voucher.sendBatch.choose": "Vui lòng chọn mã giảm giá dành riêng cho lượt theo dõi",
    "im.messageList.whereIsMyOrderTitle": "Đơn hàng gần đây",
    "page.import.historyBox.feedback.failed": "Nhập thông tin không thành công",
    "page.im.window.disconnection": "mạng ngắt kết nối",
    "page.im.setting.tab1": "Quản lý Người dùng",
    "lazada_im_sticker_like": "Thích",
    "page.im.window.voucher.sendBatch.createButton": "Tạo mã giảm giá mới",
    "lazada_im_sticker_ok": "OK",
    "page.im.window.translation.advertisements": "Alibaba Translation",
    "page.import.historyBox.col.progress": "Quá trình",
    "page.im.window.read": "Đã đọc",
    "page.im.window.view": "Xem",
    "page.import.importBox.infos.3": "Định dạng xuất: UTF8, phân cách: dấu chấm phẩy",
    "lazada_im_sticker_kisses": "Hôn nè",
    "page.im.window.units": "đơn vị",
    "page.im.window.discount.cashLabelPrefixLine1": "Giá",
    "page.import.historyBox.col.action": "Thực hiện",
    "page.im.window.voucher.sendBatch.desc": "Bạn đang gửi mã giảm giá dành riêng cho các khách hàng đã theo dõi gian hàng. Khách hàng nhận được tin nhắn này sẽ sử dụng được mã giảm giá.",
    "im.messageList.orderNumber": "Số đơn hàng",
    "page.im.window.label.all": "Tất cả",
    "page.im.window.voucher.sendBatch.errorTip": "Có lỗi xảy ra",
    "page.im.window.discount.rateLabel": "%",
    "im.messageList.unknowMessage": "[Vui lòng kiểm tra tin nhắn này trên ứng dụng Lazada.]",
    "page.im.window.voucher.sendBatch.title": "Gửi mã giảm giá dành riêng cho lượt theo dõi hàng loạt cho khách hàng",
    "page.import.historyBox.search.user": "Người dùng",
    "page.im.window.label.emptyMessage": "Không nhận được tin nhắn nào.",
    "page.im.setting.assignment.subTitle": "Vui lòng chọn tài khoản quản lí công cụ Chat của gian hàng. Chỉ duy nhất tài khoản quản lí này có thể quản lí các tài khoản chat khác (nếu có). LƯU Ý: Thông tin tài khoản quản lý không thể cập nhật hay thay đổi. ",
    "page.im.window.label.total": "Tổng",
    "page.import.footer.button.done": "Hoàn tất",
    "page.im.window.defaultText": "Loại tin nhắn không xác định.",
    "page.im.window.label.sellerSku": "Seller SKU",
    "page.im.window.voucher.sendBatch.creatingDesc": "Vui lòng KHÔNG ĐÓNG cửa sổ này để gửi mã giảm giá.\r\nNhấn chọn nút xác nhận khi bạn hoàn tất tạo mã giả giá tại cửa số mới",
    "page.im.window.draft": "NHÁP",
    "im.messageList.change": "Thay đổi",
    "page.im.setting.assignment.title": "Bạn cần chọn tài khoản quản lý tính năng Chat",
    "page.im.setting.tab2": "Trả lời Nhanh",
    "page.im.window.tab.product": "Sản phẩm",
    "page.im.setting.btn.selectAll": "khỏi tất cả các trang",
    "page.import.tab.import": "Nhập dữ liệu",
    "page.im.setting.title": "Thiết lập tính năng Chat",
    "page.im.window.label.emptyList": "Oh không có, người mua đã không mua bất cứ điều gì từ cửa hàng của bạn nào.",
    "page.import.importBox.footerTips": "Cập nhật mô tả sản phẩm bằng cách Đăng tải hàng loạt sẽ không hiển thị trong Lorikeet. Vui lòng tải sản phẩm về dưới tập tin excel để xem nội dung",
    "page.im.window.app.download": "Dùng Ứng dụng Lazada trải nghiệm Trò chuyện tốt nhất",
    "lazada_im_sticker_vouchers": "Mã giảm giá",
    "page.im.setting.confirm": "Bạn có chắc muốn xóa người dùng khỏi nhóm này",
    "page.im.window.label.message": "Chat",
    "page.im.window.process.resend": "Gửi lại",
    "im.messageList.reviewShippingInformationTitle": "Xem lại địa chỉ giao hàng",
    "im.messageList.followBtn": "Theo dõi",
    "page.im.window.voucher.sendBatch.submitSuccess": "Mã giảm giá dành riêng cho lượt theo dõi sẽ được gửi ra trong vài phút nữa.",
    "page.im.window.orderSearchPlaceholder": "Vui lòng nhập mã đơn hàng",
    "page.import.historyBox.col.status": "Trạng thái",
    "page.im.window.label.shopSku": "Shop SKU",
    "im.messageList.status": "Trạng thái",
    "page.im.window.follow.send": "Gửi lời mời",
    "page.im.window.label.status": "Trạng thái",
    "page.im.window.discount.cashLabelSuffix": "Giảm Giá",
    "page.im.window.get": "Nhận được",
    "lazada_im_sticker_buybuybuy": "Mua Mua Mua!",
    "page.import.historyBox.col.type": "Tên tập tin",
    "page.im.setting.management.title": "Hỗ trợ Khách hàng",
    "page.im.window.voucher.sendBatch.submitError": "Mã giảm giá dành riêng cho lượt theo dõi không được gửi thành công. Vui lòng thử lại",
    "page.import.title": "Nhập dữ liệu",
    "page.import.historyBox.col.created": "Đã tạo",
    "page.im.window.label.loading": "Đang tải",
    "im.messageList.productTitle": "Thông tin sản phẩm",
    "page.im.window.date.yesterday": "hôm qua",
    "page.im.setting.btn.createUser": "Tạo Người dùng có đầy đủ quyền truy cập mới",
    "page.import.historyBox.col.user": "Người dùng",
    "lazada_im_sticker_giftforyou": "Quà cho bạn",
    "page.im.window.follow.notFollow": "Khách hàng này vẫn chưa theo dõi gian hàng của bạn.",
    "page.im.window.tab.collectiveVoucher": "Phiếu thưởng tập thể",
    "page.import.importBox.importButton": "Đăng tải tập tin",
    "im.messageList.returnRequestTitle": "Yêu cầu trả hàng mới",
    "lazada_im_sticker_peep": "Bí mật",
    "page.im.setting.btn.clear": "Xóa mục đã chọn",
    "lazada_im_sticker_shoppingday": "Ngày hội mua sắm",
    "im.messageList.totalReturns": "Tổng trả hàng",
    "page.import.historyBox.link.download": "Tải về",
    "page.im.window.label.refresh": "Làm mới",
    "im.messageList.order": "Đơn hàng",
    "page.im.window.label.pending": "đang chờ xử lý",
    "page.im.setting.init.confirm": "Một khi được chọn, tài khoản quản lí sẽ không thể được thay đổi hay xóa. Hãy chắc chắn bạn đã cập nhật đúng thông tin.",
    "page.im.window.voucher.sendBatch.creatingButton": "Tạo mã giảm giá mới",
    "page.im.window.unread": "Chưa đọc",
    "im.messageList.followTitle": "Theo dõi gian hàng",
    "page.im.setting.tab3": "Trả lời Tự động",
    "page.im.window.filter.unread": "Chưa đọc",
    "im.messageList.voucherBtn": "Sưu tầm",
    "im.messageList.reviewShippingInformationItemTip": "Tổng sản phẩm"
};